"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chunk3b2cded = require("./chunk-3b2cded6.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  background-color: white;\n  position: absolute;\n  padding: 16px 0;\n  margin-top: 0px;\n  list-style: none;\n  border-radius: 4px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-shadow: ", ";\n  z-index: 3;\n  width: ", ";\n  padding: 0;\n  cursor: default;\n  &.right {\n    left: calc(100%);\n  }\n  &.up {\n    bottom: 0px;\n  }\n  &.down {\n    top: 0px;\n  }\n  &.left {\n    right: calc(100%);\n  }\n  .cmenu-section {\n    margin: 0;\n    width: 100%;\n    padding: 8px 0;\n    border-top: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n  }\n  /* if an element is adjacent to the same element type, \n  dont show the second items border */\n  .cmenu-section + .cmenu-section {\n    border-top: 0;\n  }\n\n  .option-detail-container {\n    display: block;\n    box-sizing: border-box;\n    padding: 9px 16px;\n    cursor: default;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CMenu = function CMenu(_ref) {
  var className = _ref.className,
      children = _ref.children,
      id = _ref.id;
  return _react.default.createElement(Menu, {
    className: (0, _classnames.default)("menu", "up", "right", "cmenu", className),
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    role: "menu",
    id: id
  }, children);
};

var Menu = _styledComponents.default.ul.withConfig({
  displayName: "CMenu__Menu",
  componentId: "cf3ebp-0"
})(_templateObject(), function (props) {
  return props.theme["$box-shadow-3"];
}, function (props) {
  return props.menuWidth ? props.menuWidth + "px" : "256px";
}, function (props) {
  return props.theme["$gray-2"];
}, function (props) {
  return props.theme["$gray-2"];
});

CMenu.Section = function (_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("ul", {
    className: "cmenu-section"
  }, children);
};

CMenu.Section.displayName = "Section";
CMenu.displayName = "CMenu";
CMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CMenu"
};
var _default = CMenu;
exports.default = _default;
CMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CMenu"
};